import { fmtBRL } from "../lib/format";
import { ENTRADA_METHODS, fmtISO } from "../lib/schedule";

const pInput = "w-full bg-white border border-slate-300 rounded px-2 py-1.5 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-800";
const pLabel = "text-[11px] font-semibold uppercase tracking-wide text-blue-950 shrink-0";

// Entrada (paga no ato) + vencimentos editáveis do restante — usado no formulário do pedido
export const OrderPaymentPlan = ({ form, setForm, plan }) => {
  const setDue = (i, v) => {
    const due_dates = Array.from({ length: plan.parcelas.length }, (_, k) => (form.due_dates || [])[k] || "");
    due_dates[i] = v;
    setForm({ ...form, due_dates });
  };
  const hasEntrada = plan.entrada > 0;
  return (
    <>
      <div className="bg-amber-50 border-t border-slate-300 px-4 py-3 grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="order-entrada-block">
        <div>
          <span className={`${pLabel} block mb-1`}>Entrada (paga no ato) — R$</span>
          <input data-testid="order-entrada-input" type="number" step="0.01" min="0" className={pInput} placeholder="0,00"
            value={form.entrada_value} onChange={(e) => setForm({ ...form, entrada_value: e.target.value })} />
        </div>
        <div>
          <span className={`${pLabel} block mb-1`}>Forma da entrada</span>
          <select data-testid="order-entrada-method-select" className={pInput} value={form.entrada_method} disabled={!hasEntrada}
            onChange={(e) => setForm({ ...form, entrada_method: e.target.value })}>
            {ENTRADA_METHODS.map((m) => <option key={m}>{m}</option>)}
          </select>
        </div>
        <div className="text-sm text-slate-800 sm:pt-5" data-testid="order-plan-summary">
          {plan.error ? <span className="text-rose-700 font-semibold" data-testid="order-plan-error">{plan.error}</span>
            : hasEntrada
              ? <>Entrada <b>{fmtBRL(plan.entrada)}</b> ({form.entrada_method}, já paga) + restante <b>{fmtBRL(plan.restante)}</b> em {plan.parcelas.length}x ({form.payment_method})</>
              : <span className="text-slate-500">Sem entrada — {plan.parcelas.length}x de {fmtBRL(plan.parcelas[0]?.amount || 0)} ({form.payment_method})</span>}
        </div>
      </div>
      {plan.total > 0 && !plan.error && (
        <div data-testid="order-due-dates" className="bg-slate-100 border-t border-slate-300 px-4 py-3">
          <span className={pLabel}>Vencimentos das Parcelas <span className="normal-case font-normal text-slate-500">— clique na data para alterar</span></span>
          <div className="flex flex-wrap gap-2 mt-2 items-stretch">
            {hasEntrada && (
              <span data-testid="due-date-chip-entrada" className="text-xs bg-amber-100 border border-amber-300 rounded px-2.5 py-1 text-amber-900 flex items-center gap-1">
                <span className="font-semibold">Entrada</span> · {fmtISO(form.order_date)} · {fmtBRL(plan.entrada)} · <span className="font-semibold">paga ({form.entrada_method})</span>
              </span>
            )}
            {plan.parcelas.map((p, i) => (
              <span key={i} data-testid={`due-date-chip-${i}`}
                className={`text-xs bg-white border rounded px-2.5 py-1 text-slate-800 flex items-center gap-1.5 ${p.custom ? "border-amber-400" : "border-slate-300"}`}>
                <span className="font-semibold text-blue-950">{i + 1}ª</span>
                <input data-testid={`due-date-input-${i}`} type="date" value={p.due_date}
                  onChange={(e) => setDue(i, e.target.value)}
                  className="bg-transparent border-0 p-0 text-xs text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-800 rounded" />
                · {fmtBRL(p.amount)}
                {p.custom && (
                  <button type="button" data-testid={`due-date-reset-${i}`} title="Voltar ao vencimento automático" onClick={() => setDue(i, "")}
                    className="text-[10px] text-amber-700 underline underline-offset-2">auto</button>
                )}
              </span>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
